'use client';

import { useEffect, useState } from 'react';
import { useScroll, useThrottle, useWindowSize } from 'react-use';

function useNavButtonsDisabled(listRef: any) {
  const [prevButtonDisabled, setPrevButtonDisabled] = useState(true);
  const [nextButtonDisabled, setNextButtonDisabled] = useState(true);
  const scrollState = useScroll(listRef);
  const throttledScrollState = useThrottle(scrollState, 200);
  const windowSize = useWindowSize();

  useEffect(() => {
    const listElement = listRef.current;

    if (!listElement) {
      return;
    }

    if (listElement.scrollLeft === 0) {
      setPrevButtonDisabled(() => true);
    } else {
      setPrevButtonDisabled(() => false);
    }

    if (
      Math.ceil(listElement.offsetWidth + listElement.scrollLeft) >=
      listElement.scrollWidth
    ) {
      setNextButtonDisabled(() => true);
    } else {
      setNextButtonDisabled(() => false);
    }
  }, [listRef, throttledScrollState.x, windowSize.width, windowSize.height]);

  return { prevButtonDisabled, nextButtonDisabled };
}

export default useNavButtonsDisabled;
